export default __webpack_public_path__ + "assets/static/data/auth-config.e9aac047e96b449d7db25b1ce0bbb5da.json";